import { TableV3FilterItem } from 'common/table/types/TableV3';
import { SearchableCandidateProfileListFilterInput } from 'generated-graphql/types';

// Lists in any of the selected teams.
export const getTeamsFilterClause = (
  selected: TableV3FilterItem[] | undefined
): SearchableCandidateProfileListFilterInput | undefined => {
  if (!selected?.length) {
    return undefined;
  }

  return { or: selected.map(({ value }) => ({ teamIds: { eq: value } })) };
};
